<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h3>
          <b-badge variant="primary">
            Add Household Exception
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col><strong>Household ID</strong></b-col>
      <b-col sm="8" cols=12>{{ HHID }}</b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col><strong>Family Name</strong></b-col>
      <b-col sm="8" cols=12>{{ FamilyName }}</b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col><strong>Cluster</strong></b-col>
      <b-col sm="8" cols=12>{{ Cluster }}</b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col><strong>The Issue</strong></b-col>
      <b-col sm="8" cols=12>
        <b-form-textarea
          v-model="TheIssue"
          :state="theIssueLengthInRange"
          placeholder="Enter exception notes here"
          aria-describedby="input-issue-feedback input-issue-help"
          rows="3"
          max-rows="6">
        </b-form-textarea>
        <b-form-invalid-feedback id="input-issue-feedback">
          issue too long
        </b-form-invalid-feedback>
        <b-form-text
          id="input-issue-help">
          ({{ issueLength }}/{{ maxIssueLength }})
        </b-form-text>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col><strong>Accept or Reject the data?</strong></b-col>
      <b-col sm="8" cols=12>
        <b-form-select 
          v-model="Accept" 
          :options="AcceptOptions">
        </b-form-select>
      </b-col>
    </b-row>
    <b-row class="pb-4">
      <b-col><strong>Successful Interview?</strong></b-col>
      <b-col sm="8" cols=12>
        <b-form-checkbox
          v-model="SuccessfulInterview"
          :value="true"
          :unchecked-value="false">
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" class="pb-2 pb-sm-0">
        <b-button
          :disabled="canSave() || waiting || !theIssueLengthInRange"
          block
          variant="success"
          @click="addException()">
          Save
        </b-button>
      </b-col>
      <b-col sm="6">
        <b-button
          block
          @click="$router.go(-1)">
          Close
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { apiService } from '../_services'

export default {
  name: 'AddHouseholdException',
  data() {
    return {
      waiting: false,
      HHID: '',
      FamilyName: '',
      Cluster: '',
      TheIssue: '',
      maxIssueLength: 2500,
      Accept: true,
      SuccessfulInterview: false,
      AcceptOptions: [
        {value: true, text: 'Accept'},
        {value: false, text: 'Reject'}
      ]
    }
  },
  created() {
    this.HHID = this.$route.params.hhid
    let vm = this
    this.waiting = true
    apiService.getAddHouseholdException(this.HHID)
    .then((response) => {
      vm.FamilyName = response.data.FamilyName
      vm.Cluster = response.data.Cluster
      vm.waiting = false
    })
  },
  computed: {
    theIssueLengthInRange() {
      return this.TheIssue.length > this.maxIssueLength ? false : true
    },
    issueLength() {
      return this.TheIssue.length
    },
  },
  methods: {
    // can only save if the exception notes have been entered
    canSave() {
      if (this.TheIssue == '') {
        return true
      }
      return false
    },
    addException() {
      let vm = this
      this.waiting = true
      apiService.addNewHouseholdException(this.HHID, this.TheIssue, this.Accept, this.SuccessfulInterview)
      .then(() => {
        vm.$bvModal.msgBoxOk('Household exception added')
        console.log("household exception added successfully")
        // add user confirmation of successful exception addition
        // maybe reset page to empty fields
        vm.waiting = false
      })
      .catch((err) => {
        console.log({'msg': 'error adding household exception', 'error': err})
        vm.$bvModal.msgBoxOk('Error adding household exception')
        vm.waiting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/AddHouseholdExceptionPage.vue